import { Controller } from '@hotwired/stimulus'

require("leaflet/dist/leaflet.css")
import L from 'leaflet'
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default class extends Controller {
  static targets = [ 'lat', 'lng', 'map' ]
  static values = {
    zoom: {
      type: Number,
      default: 5,
    },
  };

  connect () {
    this.resizeEvent = ((event) => this.map.invalidateSize()).bind(this);
    this.markerEvent = ((event) => this.marker()).bind(this);
    this.marker();

    this.latTarget.addEventListener('change', this.markerEvent);
    this.lngTarget.addEventListener('change', this.markerEvent);
    window.addEventListener('resize', this.resizeEvent);
    window.addEventListener('modal:show', this.resizeEvent);

    this.map.on('click', event => {
      this.latTarget.value = event.latlng.lat
      this.lngTarget.value = event.latlng.lng

      this.latTarget.dispatchEvent(new Event('change'))
    })
  }

  disconnect () {
    this.latTarget.removeEventListener('change', this.markerEvent);
    this.lngTarget.removeEventListener('change', this.markerEvent);
    window.removeEventListener('resize', this.resizeEvent);
    window.removeEventListener('modal:show', this.resizeEvent);
  }

  marker () {
    if (this._marker) this.map.removeLayer(this._marker)

    this._marker = L.marker(this.coords).addTo(this.map)

    return this._marker
  }

  get lat () {
    const lat = parseFloat(this.latTarget.value)

    return isNaN(lat) ? 0 : lat
  }

  get lng () {
    const lng = parseFloat(this.lngTarget.value)

    return isNaN(lng) ? 0 : lng
  }

  get coords () {
    return [this.lat, this.lng]
  }

  get map () {
    if (!this._map) {
      this._map = L.map(this.mapTarget).setView(this.coords, this.zoomValue)

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
      }).addTo(this._map)
    }

    return this._map
  }
}
